import React, { useEffect } from 'react';

import { usePublish } from '@atlaskit/rovo-triggers/main';

import { useCurrentConversationId } from '../../controllers/chat-store/useCurrentConversationId';
import { useChatConversation } from '../../controllers/conversation/useChatConversation';

/** Publishes the selected agent to the AI Mate channel. */
const SelectedAgentPublisherInner = ({
	selectedAgent,
}: {
	selectedAgent: ReturnType<typeof useChatConversation>['selectedAgent'];
}): null => {
	const publish = usePublish('ai-mate');

	useEffect(() => {
		if (selectedAgent?.id && selectedAgent?.name && !selectedAgent?.is_default) {
			publish({
				type: 'agent-changed',
				source: 'ai-mate',
				data: {
					agent: {
						id: selectedAgent.id,
						name: selectedAgent.name,
						identityAccountId: selectedAgent.identity_account_id,
					},
				},
			});

			return () => {
				publish({
					type: 'agent-changed',
					source: 'ai-mate',
					data: {
						agent: null,
					},
				});
			};
		}
	}, [
		selectedAgent?.id,
		selectedAgent?.name,
		selectedAgent?.identity_account_id,
		selectedAgent?.is_default,
		publish,
	]);

	return null;
};

export const SelectedAgentPublisher = (): React.JSX.Element => {
	const conversationId = useCurrentConversationId();
	const { selectedAgent } = useChatConversation({ conversationId });
	return <SelectedAgentPublisherInner selectedAgent={selectedAgent} />;
};
